import { useNavigate } from 'react-router-dom';
import { useDebounce } from 'use-debounce';

import { Dialog, DialogProps, PaperSaveLoader } from '..';


export interface RoutedDialogProps extends Omit<DialogProps, 'open'> {
    closeTo: string;
    saveLoading?: boolean;
    debounceTitle?: boolean;
    preventOpen?: boolean;
    confirmClose?: () => Promise<boolean>;
}

export type RoutedDialogImplProps = Omit<RoutedDialogProps, 'title' | 'children'>;

export function RoutedDialog({
    confirmClose, closeTo, onClose, saveLoading, children, debounceTitle, title, preventOpen, ...props
}: RoutedDialogProps) {
    const navigate = useNavigate();
    const [ debouncedTitle ] = useDebounce(title, debounceTitle ? 0 : 200);

    return (
        <Dialog
            {...props}
            title={debouncedTitle}
            open={!preventOpen}
            onClose={async (event, reason) => {
                if (reason === 'escapeKeyDown' && (!confirmClose || await confirmClose())) {
                    navigate(closeTo, { replace: true });
                    onClose?.(event, reason);
                }
            }}
        >
            {children}

            <PaperSaveLoader loading={!!saveLoading} />
        </Dialog>
    );
}
